export default {
  sm: `
    안전과 효율을 생각한 
    본관과 서버동의 분리
  `,
  lg: `
    안전과 효율을 
    생각한 본관과 
    서버동의 분리
  `
};
